// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import ConfirmVisitList from 'components/organisms/ConfirmVisitList';
import CollectRouteTemplate from 'components/templates/CollectRouteTemplate';
import { Path } from 'routes';
import { useHistory, useLocation, useParams } from 'react-router';
import { useMemo } from 'react';
import { getApiPath } from 'util/commons';

const CollectConfirmDestinations = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { routeId } = useParams<{ routeId: string }>();
  const history = useHistory();

  const listMode = useMemo(() => {
    if (!state) {
      return 'confirm';
    }

    if (typeof state === 'object' && state && 'mode' in state) {
      return state.mode === 'edit' ? 'edit' : 'confirm';
    }
  }, [state]);

  return (
    <CollectRouteTemplate
      h1={
        listMode === 'edit'
          ? t('confirm_visit_list.title_edit')
          : t('confirm_visit_list.title')
      }
      prevFunction={
        listMode === 'edit' || routeId !== 'all'
          ? () => {
              if (listMode === 'edit') {
                history.replace(
                  `${getApiPath(Path.routeSiteSelection, { routeId })}${
                    window.location.search
                  }`
                );
              } else {
                history.push(`${Path.routeList}${window.location.search}`);
              }
            }
          : undefined
      }
      checkNoneRouteId
    >
      <ConfirmVisitList mode={listMode} />
    </CollectRouteTemplate>
  );
};

export default CollectConfirmDestinations;
